// import { useState, useRef } from "react";
// import Button from "../Dealers/Button";

// const PriorityEditModal = ({ item, onConfirm, onClose, mode, activeType }) => {
//   const [val, setVal] = useState("");
//   const inputRef = useRef(null);

//   const primaryLabel = item?.voucherNo
//     ? "Voucher No"
//     : item?.machine && activeType === "Machine Wise"
//       ? "Machine"
//       : "Order Id";

//   const primaryValue = item?.voucherNo || item?.orderId || item?.machine || "-";

//   const handleConfirm = () => {
//     onConfirm(item);
//     onClose();
//   };

//   // Enter key triggers confirm
//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       handleConfirm();
//     }
//   };

//   const surface = mode ? "#1B1D21" : "#F4F6FA";
//   const border = mode ? "#2E3035" : "#E5E7EB";
//   const textMuted = mode ? "#9CA3AF" : "#6B7280";

//   const showPriority = item === "Normal" ? "Urgent" : "Normal";

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         backgroundColor: "rgba(0,0,0,0.5)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         zIndex: 10000,
//         padding: 20,
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           width: "100%",
//           maxWidth: 440,
//           backgroundColor: mode ? "#232529" : "#FFFFFF",
//           color: mode ? "#FFFFFF" : "#111827",
//           borderRadius: 20,
//           border: `0.5px solid ${border}`,
//           padding: 28,
//         }}
//       >
//         {/* Header */}
//         <div style={{ textAlign: "center", marginBottom: 24 }}>
//           <p style={{ fontSize: 18, fontWeight: 500, margin: "0 0 4px" }}>
//             Update Priority
//           </p>
//         </div>

//         <p
//           style={{
//             fontSize: 13,
//             color: textMuted,
//             //   margin: 0,
//             margin: "10px 5px",
//           }}
//         >
//           Change priority from {item} to {showPriority}
//         </p>
//         {/* Actions */}
//         <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
//           <Button
//             buttonClick={onClose}
//             buttonText="Cancel"
//             buttonBgColor="#000000"
//             buttonTextColor={"#ffffff"}
//           />
//           <Button
//             buttonClick={handleConfirm}
//             buttonText="Confirm"
//             buttonBgColor="#4164E3"
//             buttonTextColor="#FFFFFF"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PriorityEditModal;

import Button from "../Dealers/Button";

const PriorityEditModal = ({
  item,
  onConfirm,
  onClose,
  mode,
  activeType,
  priorityLoader,
}) => {
  const currentPriority = item?.priority || "Normal";

  const newPriority = currentPriority === "Normal" ? "Urgent" : "Normal";

  const handleConfirm = () => {
    if (priorityLoader) return;

    // Send complete item + new priority
    onConfirm(item, newPriority);
  };

  const isDark = mode;

  const colors = {
    overlay: "rgba(0, 0, 0, 0.55)",
    background: isDark ? "#232529" : "#FFFFFF",
    text: isDark ? "#F9FAFB" : "#111827",
    muted: isDark ? "#9CA3AF" : "#6B7280",
    border: isDark ? "#36393F" : "#E5E7EB",
    boxBg: isDark ? "#1B1D21" : "#F8F9FC",
    urgentBg: isDark ? "#3A2020" : "#FEF2F2",
    urgentText: "#EF4444",
    normalBg: isDark ? "#1E3328" : "#ECFDF5",
    normalText: "#16A34A",
  };

  return (
    <div
      onClick={priorityLoader ? undefined : onClose}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: colors.overlay,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 430,
          backgroundColor: colors.background,
          color: colors.text,
          borderRadius: 18,
          border: `1px solid ${colors.border}`,
          padding: 28,
          boxShadow: "0 20px 50px rgba(0, 0, 0, 0.2)",
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              backgroundColor:
                newPriority === "Urgent" ? colors.urgentBg : colors.normalBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 12px",
              fontSize: 22,
              fontWeight: 600,
              color:
                newPriority === "Urgent"
                  ? colors.urgentText
                  : colors.normalText,
            }}
          >
            {newPriority === "Urgent" ? "!" : "✓"}
          </div>

          <h3
            style={{
              margin: 0,
              fontSize: 18,
              fontWeight: 600,
              color: colors.text,
            }}
          >
            Update Priority of{" "}
            <span style={{ color: "#4164E3" }}>{item?.orderId}</span>
          </h3>

          <p
            style={{
              margin: "7px 0 0",
              fontSize: 13,
              color: colors.muted,
            }}
          >
            Are you sure you want to change the priority?
          </p>
        </div>

        {/* Priority Change */}
        <div
          style={{
            backgroundColor: colors.boxBg,
            border: `1px solid ${colors.border}`,
            borderRadius: 12,
            padding: "18px 16px",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            {/* Current */}
            <div
              style={{
                flex: 1,
                textAlign: "center",
              }}
            >
              <p
                style={{
                  margin: "0 0 8px",
                  fontSize: 11,
                  color: colors.muted,
                  fontWeight: 500,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                Current Priority
              </p>

              <span
                style={{
                  display: "inline-block",
                  padding: "7px 14px",
                  borderRadius: 8,
                  backgroundColor:
                    currentPriority === "Urgent"
                      ? colors.urgentBg
                      : colors.normalBg,
                  color:
                    currentPriority === "Urgent"
                      ? colors.urgentText
                      : colors.normalText,
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {currentPriority}
              </span>
            </div>

            {/* Arrow */}
            <div
              style={{
                fontSize: 20,
                color: colors.muted,
                paddingTop: 18,
              }}
            >
              →
            </div>

            {/* New */}
            <div
              style={{
                flex: 1,
                textAlign: "center",
              }}
            >
              <p
                style={{
                  margin: "0 0 8px",
                  fontSize: 11,
                  color: colors.muted,
                  fontWeight: 500,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                New Priority
              </p>

              <span
                style={{
                  display: "inline-block",
                  padding: "7px 14px",
                  borderRadius: 8,
                  backgroundColor:
                    newPriority === "Urgent"
                      ? colors.urgentBg
                      : colors.normalBg,
                  color:
                    newPriority === "Urgent"
                      ? colors.urgentText
                      : colors.normalText,
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                {newPriority}
              </span>
            </div>
          </div>
        </div>

        {/* Message */}
        <p
          style={{
            margin: "0 0 24px",
            textAlign: "center",
            fontSize: 13,
            lineHeight: 1.5,
            color: colors.muted,
          }}
        >
          Change priority from{" "}
          <strong style={{ color: colors.text }}>{currentPriority}</strong> to{" "}
          <strong
            style={{
              color:
                newPriority === "Urgent"
                  ? colors.urgentText
                  : colors.normalText,
            }}
          >
            {newPriority}
          </strong>
          .
        </p>

        {/* Actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Button
            buttonClick={onClose}
            buttonText="Cancel"
            buttonBgColor={"#000000"}
            buttonTextColor="#FFFFFF"
            disabled={priorityLoader}
          />

          <Button
            loading={priorityLoader}
            buttonClick={handleConfirm}
            buttonText="Confirm"
            buttonBgColor="#4164E3"
            buttonTextColor="#FFFFFF"
          />
        </div>
      </div>
    </div>
  );
};

export default PriorityEditModal;
